import { NextPageContext } from 'next';

import { NestedReturnReasonOption } from '@rebound/shared-models/retailer/retailer.model';

import { Environment, environmentConfig } from '@config';
import { getEnvOrDefault } from '@config/runtime-env';

export const getSubdomainFromContext = (ctx: NextPageContext) => {
  let subdomain = '';

  if (
    ctx.req &&
    ctx.req.headers.host &&
    environmentConfig.environment !== Environment.Development
  ) {
    subdomain = ctx.req.headers.host.split('.')[0] || '';
  }

  if (environmentConfig.environment === Environment.Development) {
    subdomain = getEnvOrDefault('NEXT_PUBLIC_DEV_SUBDOMAIN', '');
  }

  return subdomain;
};

export const getSubdomainFromLocation = () =>
  environmentConfig.environment !== Environment.Development
    ? window.location.host.split('.')[0] || ''
    : getEnvOrDefault('NEXT_PUBLIC_DEV_SUBDOMAIN', '');

export const formatNestedReturnReasons = (
  reasons: NestedReturnReasonOption[],
) => {
  if (!reasons || !Array.isArray(reasons)) return [];

  return reasons.map((reason) => {
    const categoryPrettyName = Array.isArray(reason.reasonCategoryPrettyName)
      ? Object.fromEntries(
          reason.reasonCategoryPrettyName.map((obj: any) => [
            obj.key,
            obj.value,
          ]),
        )
      : reason.reasonCategoryPrettyName || {};

    return {
      ...reason,
      reasonCategoryPrettyName: categoryPrettyName,
      subReasons: (reason.subReasons || []).map((subreason) => {
        const prettyName = Array.isArray(subreason.prettyName)
          ? Object.fromEntries(
              subreason.prettyName.map((obj: any) => [obj.key, obj.value]),
            )
          : subreason.prettyName || {};

        const commentPlaceholder = Array.isArray(subreason.commentPlaceholder)
          ? Object.fromEntries(
              subreason.commentPlaceholder.map((obj: any) => [
                obj.key,
                obj.value,
              ]),
            )
          : subreason.commentPlaceholder || {};

        return {
          ...subreason,
          prettyName,
          commentPlaceholder,
        };
      }),
    };
  });
};
